// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__Zaca_","itemTitle":"ClientEmergencyInfo_itemTitle__1ugvv","itemText":"ClientEmergencyInfo_itemText__2loH_"};